<template>
<div class="container-fluid" >

    <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>


<waitingModal v-if="waitModal.show" @close="closeWaitingModal()"  v-bind:props="waitModal"></waitingModal>
<div class="card border-success">

  <div class="card-header text-white bg-primary">
    <h4><i style="color:#FFD700" class="fas fa-chart-area mr-2" aria-hidden="true"></i>SELL OUT TUTTI I FORNITORI </h4>
  </div> 

 <div  class="card-body"> 
  <div class="row">
  <div v-if="items.length==0" class="col"> 

  <div  class="" >
  <div class="">
    <i style="color:blue" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong>
  <hr>
  </div>
  <div class="card-body text-black">

  <form name="filter" v-on:submit.prevent="getData()">

  <div class="row">
    <div class="col-md-4">
        <collectionSelect  v-bind:props="collection" @update="setCollectionId"></collectionSelect>                        
        <collectionOptionType class="ml-3 mb-3" v-bind:typeId="collection.typeId" v-bind:option="1"  @update="setCollectionTypeId"></collectionOptionType>        
    </div>
  </div>  
  <div class="row">
    <div v-if="1==0" class="form-group col-md-4">
    <label for="date_doc"><strong>DATA ULTIMO ACQUISTO / RESO A FORNITORE</strong></label>
    <div class="input-group">  
    <input  v-model="data2" type="date" class="form-control" placeholder="" >         
    
    </div>
  </div>

 <div class="col-md-3">  
      <store-select v-bind:props="store"  @update="setStoreId"></store-select>     
    </div>

  <div class="form-group col-md-4 mb-4">
        <label for="date_doc"><strong>DATA ULTIMA VENDITA</strong></label>
        <input  v-model="dataUltimaVendita" type="date" class="form-control" placeholder="" >        
  </div>  
  
  </div>


    <span style="color:brown"><strong>FILTRO PRODOTTI COLLEZIONE</strong></span>
    
    <div  class="row">    
    <div class="col-md-2">    
      <season-vue-select  @update="setSeasonId" v-bind:props="season"></season-vue-select>
    </div>
   
    <div class="col-md-2">  
      <year-select  v-bind:props="season_year" @update="setYear"></year-select>
    </div>
    
    <div class="col-md-2">          
      <departmentVueSelect v-bind:props="department" @update="setDepartmentId"></departmentVueSelect>
    </div>  
    <div class="col-md-3"> 
    <category-grouping v-bind:props="catGrouping" @update="setGroupCategoryId"></category-grouping>
    </div>
    </div> 

    <hr></hr>
  
  <span class="mt-4"><strong>TIPO RAGGRUPPAMENTO</strong></span>  
  
  <div class="form-check">
  <input class="form-check-input" type="radio" name="exampleRadios0" id="exampleRadios0" :value="1" v-model="group_by"  checked>
  <label class="form-check-label" for="exampleRadios0">
    FORNITORE
  </label>
  </div>

  
  <div class="form-check">
  <input class="form-check-input" type="radio" name="exampleRadios1" id="exampleRadios1" :value="2" v-model="group_by">
  <label class="form-check-label" for="exampleRadios1">
    BRAND
  </label>
  </div>

  <div class="form-check mb-1">
  <input class="form-check-input" type="radio" name="exampleRadios3" id="exampleRadios3" :value="3" v-model="group_by" >
  <label class="form-check-label" for="exampleRadios3">
    BRAND - GRUPPO/CATEGORIA
  </label>
  </div>


  <div class="form-check mb-1">
  <input class="form-check-input" type="radio" name="exampleRadios2" id="exampleRadios2" :value="4" v-model="group_by" >
  <label class="form-check-label" for="exampleRadios2">
    CATEGORIA
  </label>
  </div>

  <div>
  <span><strong>TIPO REPORT</strong></span> 
  <div class="form-check ">
    <input @click="department.isActive = false" class="form-check-input" type="radio" name="inlineRadioReport1" id="inlineRadioReport1" :value="1" v-model="reportId">
    <label class="form-check-label" for="inlineRadioReport1">SINTETICO</label>
  </div>
  <div class="form-check mb-1">
    <input @click="department.isActive = true" class="form-check-input" type="radio" name="inlineRadioReport2" id="inlineRadioReport2" :value="2" v-model="reportId">
    <label class="form-check-label" for="inlineRadioReport2">ANALITICO</label>
  </div>
  </div>

  <div v-if="reportId==1">
  <span ><strong>TIPO ORDINAMENTO</strong></span> 
  <div class="form-check ">
    <input  class="form-check-input" type="radio" name="inlineRadioOptionsOrder1" id="inlineRadio1Order" value="1" v-model="orderBy">
    <label class="form-check-label" for="inlineRadio1Order">SELLTHR-COSTO</label>
  </div>
  <div class="form-check mb-2">
    <input  class="form-check-input " type="radio" name="inlineRadioOptionsOrder2" id="inlineRadio2Order" value="2" v-model="orderBy">
    <label class="form-check-label" for="inlineRadio2Order">BEP</label>
  </div>
  </div>


   <div class="card-footer bg-transparent border-info"> 
     <!--
     <button @click="items=[],row_total=[]" type="button"   class="btn btn-outline-secondary float-left">
       <i class="fas fa-redo-alt mr-2"></i>
      
        RESET
    </button>   
    -->
  <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>  
   <button :disabled="spinner" type="submit"  class="btn btn-primary float-left">
    <i class="far fa-play-circle mr-2"></i>
    ESEGUI RICERCA
      <!--<span v-if="spinner" class="spinner-border spinner-border-sm ml-3 text-warning" role="status" aria-hidden="true"></span>-->
     </button>           

  

</div>

</form>

</div>
</div>
</div>



<div v-else class="col">

<!--<filter-cols  @update="setFilter" v-bind:header="getTableHeader()" ></filter-cols>-->
 



<!-- REFRESH ON FILTERING-->
<div v-if="filter">






<!-- Modal -->
<div  class="modal" id="modalFilter" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog border border-info">
    <div class="modal-content">
      <div class="modal-header border border-info">
        <h5 class="modal-title" id="staticBackdropLabel">MOSTRA/NASCONDI COLONNE</h5>
         <!--<button  type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>-->
      </div>
      <div class="modal-body">
    
        <form>
        <label v-for="col in filteredCols" :key="col.key" style="display: block; margin-bottom: 5px;">
          <input type="checkbox" v-model="col.visible" />
          {{ col.label }}
        </label>
      </form>
        <!--
        <div class="progress-bar progress-bar-striped" role="progressbar"  :style="{'width':getProgress}">
          {{ progress }}%
        </div>
        -->  

      </div>
      <div class="modal-footer">
         
        <button @click="setFilteredColumns()" type="button" class="btn btn-primary" data-dismiss="modal">CHIUDI</button>
        
      </div>
    </div>
  </div>
</div>
<!--   MODAL  -->

 <cancel-btn @click="items=[],row_total=[]" class="mb-1" v-bind:text="'RITORNA A PARAMETRI RICERCA'"></cancel-btn>

  <h4 class="ml-4">
    SELL OUT TUTTI I FORNITORI TIPO RAGGRUPPAMENTO  <strong> <span class="ml-3"> {{ selectedGroup }}</span></strong>
  </h4>
  <h4 class="ml-4"><strong>VALORI IN € IVA ESCLUSA</strong></h4> 

 <div class="row">
  
    <button v-if="1==0" type="button" class="btn btn-info ml-3 mb-1 mr-3 " data-toggle="modal" data-target="#filterModal">
      <i class="fas fa-filter mr-2"></i>
      FILTRA COLONNE
    </button>  


    <!-- Button trigger modal -->
    <button type="button" class="btn btn-info mb-1 mt-1 ml-4" data-toggle="modal" data-target="#modalFilter">
      MOSTRA/NASCONDI COLONNE
    </button>
    <button :disabled="progress > 0" @click="elaboraPDF()" type="button"   class="btn btn-primary mb-1  ml-4">
      <i class="fas fa-file-export mr-2"></i>
      ESPORTA IN PDF
      <span v-if="progress > 0" class="spinner-border spinner-border-sm ml-4" role="status" aria-hidden="true"></span>
    </button>  
    
     <button v-if="1==0"  @click="setParams()" type="button"   class="btn btn-warning mb-1 ml-4">
      <i class="fas fa-chart-pie mr-2"></i>
      GRAFICO VENDUTO (ie) €
      
    </button>  
    
    
    
    
    
  </div>
  

  <chartModal v-if="1==0" @close="params.companyId=0" v-bind:params="params"></chartModal>
 
  <tableGrid v-bind:cols="cols" v-bind:rows="rows" v-bind:row_total="row_total" v-bind:reportId="reportId" ></tableGrid>



</div>
</div>  

</div>

<!-- card body -->
 </div>
 </div>
</div>


</template>
<script>

import api               from '@/api'
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import seasonVueSelect   from '@/components/common/SeasonVueSelect_1.vue'
import yearSelect        from '@/components/common/YearVueSelect.vue'
import departmentVueSelect  from '@/components/common/DepartmentVueSelect.vue'
import storeSelect       from '@/components/common/StoreSelect_1.vue'
// import filterCols        from '@/components/common/ModalFilterCols.vue'
import jsPDF             from 'jspdf'
import cancelBtn         from '@/components/common/CancelBtn.vue'
import fmt               from '@/components/mixins/fmt'
import chartModal        from '@/components/gchart/gchart2.vue'  
import waitingModal      from "@/components/common/WaitingModal.vue"
// import {setFmtDate1}     from '@/functions'   
import collectionSelect        from '@/components/common/CollectionSelect_1.vue' 
import collectionOptionType    from '@/components/backOffice/CollectionOptionType.vue' 
import categoryGrouping   from '@/components/common/CategoryGroupingSelect_1.vue'
import tableGrid          from '@/components/stat/SellOut_AllSuppliersGrid.vue'
import modalMessage           from '@/components/modalDialog/ModalMessage.vue'  



//import 'jspdf-autotable'
//import autoTable from 'jspdf-autotable'



export default {
  mixins     : [fmt],
  components: {alertBox,yearSelect,storeSelect,cancelBtn,
    chartModal,waitingModal,seasonVueSelect,
    departmentVueSelect,collectionSelect,collectionOptionType,categoryGrouping,tableGrid,modalMessage},
  data() {
    return {
      
      
      cols            : [],
      rows            : [],
      reportId        : 1,  
      collection      : 
      {
        Id            : 0,
        isActive      : true,       
        optionBase    : false,
        required      : true,
        typeId        : 3,
        text          : ''
        
      },  
      groupByOptions: {
        1: 'FORNITORE',
        2: 'BRAND',
        3: 'BRAND - GRUPPO/CATEGORIA',
        4: 'CATEGORIA'
      },

      orderBy      : 1,
      waitModal    : {

            sentinel   : 0,
            show       : false,
            msg1       : 'ELABORAZIONE IN CORSO ...',
            msg2       : '' 

      },

      btn_chart       : false,
      params          : {companyId:0},
      //checkBox        : true,
      total_rows      : true,
      // temp_rows       : [],
      //header_col      : [],
      //col             : [],
      filter          : true,

      store             : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false,
        text          : ''
      },
      season          : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : false,
        required      : false,
        Ids           : '',
        selection     : [],
        text          : ''
      },
      department      : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false,
        Ids           : '',
        selection     : [],
        text          : ''
      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false,
        Ids           : '',
        selection     : [],
        text          : ''

      },
      catGrouping     : {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false,
        text          : ''
      },  

      title           : {store : 'Tutte',department:'Tutti'}, 
      data1           : null,
      
      data2           : new Date().toISOString().slice(0,10),
      dataUltimaVendita : new Date().toISOString().slice(0,10),
      data4           : new Date().toISOString().slice(0,10),      
      spinner         : false,
      spinner_pdf     : false,
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      items           : [],
      row_total       : [],
      
      group_by        : 1,
      bt_spinner      : false,
      progress        : 0,
      filteredCols    : [],
      
     
      
      
    };
  },

  computed :{
    ...mapGetters(['company']),
   
    selectedGroup() {
      return this.groupByOptions[this.group_by];
    },

    getProgress()
    {
      let p = this.progress
      return p + "%";
    },



  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },

 
   mounted: async function() {

    // this.checkServiceTime();


  },
  created: function() {

   const filteredCols =  JSON.parse(localStorage.getItem("filteredCols"));
   
    this.filteredCols = this.getTableHeader(filteredCols).filter(
                col => col.filter === true ) 
   
   



    // Salvataggio
    //localStorage.setItem("filteredCols", JSON.stringify(this.filteredCols));

    





  },
  methods: {

  async checkServiceTime() {

    const allowedRanges = [
      { start: "13:00", end: "16:00" },
      { start: "20:30", end: "08:00" }
    ];

    const now = new Date();
    const nowMinutes = now.getHours() * 60 + now.getMinutes();

    const isAllowed = allowedRanges.some(r => {

      const [sh, sm] = r.start.split(":").map(Number);
      const [eh, em] = r.end.split(":").map(Number);

      const start = sh * 60 + sm;
      const end = eh * 60 + em;

      if (start <= end) {
        return nowMinutes >= start && nowMinutes <= end;
      }

      return nowMinutes >= start || nowMinutes <= end;
    });

    if (!isAllowed) {

      await this.$refs.msgModal.show(
        "SERVIZIO DISPONIBILE NELLE SEGUENTI FASCE ORARIE:\n" + allowedRanges[0].start + ' - ' + allowedRanges[0].end + '\n' + allowedRanges[1].start + ' - ' + allowedRanges[1].end ,
        { title: "MESSAGGIO" },
        1
      );

      if (this.$router) {
        this.$router.go(-1);
      } else {
        window.history.back();
      }

      return false;
    }

    return true;
  },

        setFilteredColumns()
        {
          localStorage.setItem("filteredCols", JSON.stringify(this.filteredCols));
          const cols = this.filteredCols                    
          this.cols = this.getTableHeader(cols)                    
          
        },


getBodyRow(row, item,cols) {
  
 
  const formatters = {
      1: this.fmt1,
      2: this.fmt2,
      3: this.fmt3
    };

 
    cols.forEach((data) => {
      const { key, label, visible, format } = data;
      if (!label || visible === false)  return;

      const value = item[key];
      const formatter = formatters[format];

      row.push(formatter && typeof formatter === 'function' ? formatter(value) : value);
      
    });

    return row;
  },


      async processItems(items) {
        return new Promise(async (resolve) => {
            let r = 0
            this.progress = 0
            const body = []

            // Aggiornamento della progressione ogni N elementi
            const batchSize = 1 // puoi aumentare se ci sono molti elementi

            for (let i = 0; i < items.length; i++) {
              const item = items[i]

              if (item.groupingId === 1) {
                const row = this.getBodyRow([], item)
                body.push(row)
              }

              r++
              /*
              // Aggiorna la barra ogni batchSize elementi o all'ultimo
              if (i % batchSize === 0 || i === items.length - 1) {
                this.progress = Math.round((r / items.length) * 100)
                await this.$nextTick() // forza Vue ad aggiornare il DOM
              }
              */
              // Piccolo delay per non bloccare il browser
              await new Promise(resolve => setTimeout(resolve, 10))
    }

              // Alla fine assicuriamo 100%
              //this.progress = 100
              //await this.$nextTick()

              resolve(body)
          })
},

      wait(ms) 
      {
        return new Promise(resolve => {
        setTimeout(() => { resolve('') },ms);
        })
      },
      showProgressModal() {
         this.$nextTick(() => {
        $('#modalProgressBar').modal('show')
        })
      },
      getFiltro(dati) {
      return Object.entries(dati)
      .filter(([_, valore]) => valore != null )
      .map(([chiave, valore]) =>
      chiave === "STAGIONE"
        ? `${chiave} : ${valore}`
        : `${chiave} = ${valore}`
    )
    .join(" - ");
  },


    setGroupCategoryId(Id,e)
    {
      
      

      this.catGrouping.Id = Id
      this.catGrouping.text = e.target.options[e.target.options.selectedIndex].text  
      
      if(Id == 0)
      {
        this.catGrouping.text = ''
      }

    
    },
   setCollectionId(Id,e)
    {
      
      this.collection.Id = Id
      this.collection.text = e.target.options[e.target.options.selectedIndex].text 
      //console.log(this.pdf_title)  

    },
    setCollectionTypeId(Id)
    {
      this.collection.typeId = Id
      
    },  
  /*  
  setFmt(data)  
  {
    if(data)
    {
     return setFmtDate1(data)
    }  
  },
  */
  resetData()
  {
    //this.data1 = null
    //this.data2 = null

  },
  closeWaitingModal()
    {
      this.waitModal.show = false
      this.waitModal.sentinel = 0
      
    },

  getTableHeader(filteredCols)
  {
            
    console.log('FILTERCOLS',filteredCols)

    let allColumns = [
                        {key : 'gruppo',             label : ''},
                        {key : 'groupingId',         label : '',format:0},
                        {key : 'supplier',           label : 'FORNITORE'},
                        {key : 'brand',              label : 'BRAND'},
                        {key : 'cat_group',          label : 'GRUPPO'},
                        {key : 'category',           label : 'CATEGORIA'},
                        {key : 'season',             label : 'STAGIONE'},
                        {key : 'season_year',        label : 'ANNO'},
                        {key : 'department',         label : 'REPARTO'},
                        {key : 'qtaAcquistata',      label : 'ACQUISTATO',format:2},
                        {key : 'qtaResa',            label : 'RESO',format:2},
                        {key : 'qtaVenduta',         label : 'VENDUTO','format':2},
                        {key : 'sellThrQta',         label : 'SELLTHR-UNITA',format:3},
                        {key : 'valoreAcquistato',   label : 'ACQUISTATO €',visible:true, 'format':1,filter:true},
                        {key : 'valoreVenduto',      label : 'VENDUTO €',visible:true,'format':1,filter:true},
                        {key : 'costoVenduto',       label : 'COSTO VENDUTO €',visible:true,'format':1,filter:true},
                        {key : 'sellThrCosto',       label : 'SELLTHR-COSTO',visible:true,filter:true,format:3},
                        {key : 'bep',                label : 'BEP',selected:1,visible:true,filter:true,format:3},
                        {key : 'qtaVendutaRetail',   label : 'VENDUTO RETAIL UNIT',visible:false,'format':2,filter:true},
                        {key : 'qtaVendutaMarket',   label : 'VENDUTO ONLINE UNIT',visible:false,'format':2,filter:true},
                        {key : 'valoreVendutoMarket',label : 'VENDUTO ONLINE €',visible:false,'format':1,filter:true},
                        {key : 'stock',              label : 'STOCK',visible : true,filter:true,format:2},
                        {key : 'valoreStock',        label : 'VALORE STOCK',visible:true,'format':1,filter:true},
                        {key : 'utile',              label : 'UTILE',visible:true,'format':1,filter:true},
                        {key : 'margine',            label : 'MARGINE',visible:true,filter:true}]
          

          if( filteredCols instanceof Array  &&  filteredCols.length > 0)              
          {            
            const lookup = Object.fromEntries(filteredCols.map(item => [item.key, item.visible]))                  
            allColumns.forEach(item => {
                     if ("visible" in item)
                     {item.visible = lookup[item.key]}  
                    
                
            });
            
          }
          
          if (this.reportId === 1) {
          
              const mappaEsclusioni = {
                1: ['BRAND', 'GRUPPO', 'CATEGORIA'],
                2: ['FORNITORE', 'GRUPPO', 'CATEGORIA'],
                3: ['FORNITORE', 'CATEGORIA'],
                4: ['FORNITORE', 'BRAND', 'GRUPPO']
              };

              const comuni = ['STAGIONE', 'ANNO', 'REPARTO']

              const labelsDaEscludere = [
                ...(mappaEsclusioni[this.group_by]),
                ...comuni
              ];

              allColumns = allColumns.filter(
                item => !labelsDaEscludere.includes(item.label)
              )
            }
  
          return allColumns
  },  

  setParams()
  {
    this.params.sp        = 'spSellOutAllSuppliersChartData'
    this.params.companyId = this.company.Id
    this.params.storeId   = this.store.Id
    this.params.data1     = this.data1
    this.params.data2     = this.data2
    this.params.data3     = this.data3
    this.params.seasonId  = this.season.Id
    this.params.year      = this.season_year.year



  } , 
  showAllCols()
  {
    for (let i = 0; i < 9; i++) {
          this.col[i]= true
          } 

  },
  setFilter(cols)
  {
        
    this.filter = false
     for (let i = 0; i < cols.length; i++) 
     {
          this.col[i] = cols[i]['selected']
         
     } 
    this.filter = true      
        
  },  
   

  async elaboraPDF()
  {
  
    this.progress = 1
    const doc = new jsPDF({orientation: "landscape" })    

    let cols = this.getTableHeader(this.filteredCols)  

    const header = cols.filter(item => item.visible === true || item.visible === undefined) 
      .map(item => item.label);
      
    const head = [header]
    head[0].splice(0,2)

    /* AUTOTABLE */
    const autoTable = async (items,y)  => {
                        
            const body   = []
          
            for (let i = 0; i < items.length; i++) 
            {
              const item = items[i]
              if(item.groupingId == 1)
              {
                const row = this.getBodyRow([],item,cols)         
                body.push(row)
                
              }
              await this.wait(0) 
              /*
              r++
              this.progress = Math.round(r / items.length * 100)              
              await this.wait(0)  
              */
              

              
             
            }
            
            
           const columnStyles = { 0: { halign: 'left',cellWidth: 'auto' } }; 
            for (let i = 1; i < head[0].length; i++) { 
                columnStyles[i] = { halign: 'right',cellWidth: 'auto', whiteSpace: 'nowrap' }

          }
          
                 
              

    doc.autoTable({
       
      startY: y,
      head,
      body,
      theme: 'grid',   
      columnStyles,
      willDrawCell: function (data) 
      { 
        const lastRowIndex = data.table.body.length - 1
        // Se siamo sull'ultima riga 
        if (data.row.index === lastRowIndex) 
        { 

          // doc.setFillColor(230, 230, 230)
          // doc.rect( data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'F' ); 
        } 
      } ,
      
      styles: {
       /* cellWidth  : 'auto',*/
        /*overflow   : 'visible',*/
        fontSize   : 8,
        halign     : 'center',
        
        },
    
      headStyles: {
        //columnStyles,
       /* overflow   : 'visible',*/
        fontSize  : 6,
        fillColor : [192,192,192],   // verde
        textColor : [0,0,0],     // nero
        //fontStyle : 'bold',
        lineWidth : 0.8
      },
      
      didParseCell: function (data) {
    
      if (data.section === 'head' && data.column.index < 1) { 
        //data.cell.styles.fillColor = [129, 133, 137]; 
      }
      if (data.section === 'head' ) { 
        //data.cell.styles.overflow = 'hidden'; 
        //data.cell.styles.cellWidth = 'auto'; 
        
      }

    // SOLO body
    if (data.section !== 'body') return;

      if (data.column.index == 0) { 
        //data.cell.styles.overflow = 'hidden'; 
        //data.cell.styles.cellWidth = 'auto'; 
      }


      const lastRowIndex = data.table.body.length - 1; 
      if (data.row.index === lastRowIndex && data.section === 'body') 
      { 
        //data.cell.styles.fontSize =   10 ; 
        //data.cell.styles.fontStyle = 'bold'; 

      }
    

    },

      margin: { left: 10, right: 10 },

    });

  
        /* HEADER */
        const header = (page) =>{
  
            const filtro = {'STAGIONE':this.season.text,'ANNO' : this.season_year.text,
            'REPARTO':this.department.text,
            'GRUPPO' : this.catGrouping.text,
            'SEDE'   : this.store.text
            }
            

            doc.setPage(page)

            doc.setDrawColor(0)
            doc.setFillColor(0,0,153)
            doc.roundedRect(3, 3, 292, 5,1,1,'FD')      


            doc.setFontSize(10)
            doc.setFont("helvetica",'bold')
            doc.setTextColor(255, 255, 255)  
            doc.text('SELL OUT ' + ' COLLEZIONE ' + this.collection.text   , 150, 6.5,null,null,'center');
            doc.setTextColor(0, 0, 0)  
            
            doc.setFontSize(7)
            doc.setFont("helvetica",'italic')
            doc.text( 'Tipo raggruppamento ' + this.selectedGroup,  150, 10.5,null,null,'center');
            doc.text( '' + this.getFiltro(filtro),  150, 13.5,null,null,'center');
            doc.setFont("helvetica",'normal')

            




      }

      /*  LAST PAGE */
      const addLastPage = () =>{
            
            // REPORT SINTETICO
            if(this.reportId == 1)
            {
              doc.deletePage(1)
            }
            doc.addPage()                        
            const body   = []
            this.items.forEach(item=>{              
            
            if(item.groupingId == 2)
            {
                           
              const row = []                           
              body.push(this.getBodyRow(row,item,cols))
              
            }
          })
          this.row_total.forEach(item => {
            const row = []
              
              //row.push('TOTALE')
              body.push(this.getBodyRow(row,item,cols))

          })
          


     const columnStyles = { 0: { halign: 'left',cellWidth: 'auto' } }; 
            for (let i = 1; i < head[0].length; i++) { 
                columnStyles[i] = { halign: 'right',cellWidth: 'auto' }

          }

    let y = 22     
    doc.autoTable({
      startY: y,
      head,
      body,
      theme: 'grid',   
      columnStyles,
      willDrawCell: function (data) 
      { 
        const lastRowIndex = data.table.body.length - 1
        // Se siamo sull'ultima riga 
        if (data.row.index === lastRowIndex) 
        { 
          
          doc.setFillColor(230, 230, 230)
          doc.rect( data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'F' ); 
        } 
      } ,
      
      styles: {
        fontSize: 8,
        halign: 'center'
        },
    
      headStyles: {
        fontSize  : 6,
        fillColor : [0,128,128],   // verde
        textColor : [255, 255, 255],     // nero
        // fontStyle : 'bold',
        lineWidth : 0.8
      },
      
      didParseCell: function (data) {
    
        if (data.section === 'head' && data.column.index < 1) 
        { 
          //data.cell.styles.fillColor = [129, 133, 137]; 
        }
        if (data.section === 'head' ) 
        { 
          //data.cell.styles.overflow = 'hidden'; 
          //data.cell.styles.cellWidth = 'auto'; 
          
        }

    // SOLO body
    if (data.section !== 'body') return;

      if (data.column.index == 0) { 
        //data.cell.styles.overflow = 'hidden'; 
        //data.cell.styles.cellWidth = 'auto'; 
      }


      const lastRowIndex = data.table.body.length - 1; 
      if (data.row.index === lastRowIndex && data.section === 'body') 
      { 
        data.cell.styles.fontSize =   10 ;
        data.cell.styles.fontStyle = 'bold'; }

    
    

    },

      margin: { left: 10, right: 10 },


    });

    
}
            



    addLastPage() 

    // ULTIMA PAGINA 
    const totalPages = doc.internal.getNumberOfPages();
    doc.setFont('helvetica', 'normal')  
    for (let i = 1; i <= totalPages; i++) {

        doc.setPage(i);
        header(i)
        doc.setFontSize(9);
        doc.text(
          `Pagina ${i}/${totalPages}`,
          doc.internal.pageSize.width - 30,
          doc.internal.pageSize.height - 10
        );
      }
    
      
    this.progress = 0  
    //$('#modalProgressBar').modal('hide')  
    window.open(URL.createObjectURL(doc.output("blob")))

    } 

    autoTable(this.items,15)


  },

 
    
    setDepartmentId(Ids,text)
    {
           
      this.department.selection = Ids
      this.department.text = text
      let departmentIds = ''
      if (Ids.length > 0)
      {
        departmentIds = Ids.join() 
      }
       
      this.department.Ids = departmentIds


    },
    
    setSeasonId(Ids,text,seasonId,e)
    {   
      
      this.season.selection = Ids
      this.season.text = text
      let seasonIds = ''
      if (Ids.length > 0)
      {
        seasonIds = Ids.join() 
      }
       
      this.season.Ids = seasonIds
      

    }, 
    setYear(Ids,text)
    {
      
      let items = ''      
      
      this.season_year.selection = Ids
      this.season_year.text = text     
      if (Ids.length > 0)
      {
        items = Ids.join() 
      }
      this.season_year.Ids = items
         

    },     
  
     setStoreId(storeId,e)
    {
      
      this.store.Id = storeId
      this.store.text = e.target.options[e.target.options.selectedIndex].text  
    },  
    
    
     async getData() {




      this.cols      = []
      this.rows      = []
     
      this.row_total = []
      this.items     = []
            
     
      const sp = 'spSellOutAllSuppliersCollection'            
      const payload  = {

        'companyId'          : this.company.Id,       
        'dataUltimaVendita'  : this.dataUltimaVendita,
        'seasonIds'          : this.season.Ids,
        'yearIds'            : this.season_year.Ids,
        'departmentIds'      : this.department.Ids,
        'storeId'            : this.store.Id,
        'group_by'           : this.group_by,
        'collection'         : this.collection,
        'cat_groupId'        : this.catGrouping.Id,
        'reportId'           : this.reportId,
        'order_by'           : this.orderBy,
        sp
        
        /*'orderBy'      : this.orderBy,*/
              
      
      }
      
      // console.log(data)

        try{
        
          this.$refs.msgModal.show()        
          this.$refs.msgModal.setSpinner(true)  
          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
             
            

             this.$refs.msgModal.close() 
             this.items = res.data.recordsets[0]
             
             if(this.reportId==1)
              {
                this.items = res.data.recordsets[0].filter(item => item.groupingId == 2)
                const nuovoArray = this.items.map(({ gruppo, ...rest }) => rest);
                this.items = nuovoArray
              }
              else
              {
                this.items = res.data.recordsets[0].filter(item => item.groupingId==1 || item.groupingId == 2)
              
              }   
             
              this.rows = this.items
              this.row_total = res.data.recordsets[0].filter(item=>item.groupingId==3)

              this.cols = this.getTableHeader(this.filteredCols).filter(
                col => col.visible === true || col.visible === undefined)
             
             if(res.data.recordsets[0].length ==0) 
             {
              throw 'DATI INESISTENTI.'
             }

        }catch(err){

            this.$refs.msgModal.setSpinner(false)
            this.$refs.msgModal.show(err,{},1) 
        }
    
    
      

              
             
 

    },


    async getDataCopy() {

      this.cols      = []
      this.rows      = []
     // this.showAllCols()
      this.row_total = []
      this.items     = []
            
      this.msg.title = ''   
      const sp = {'sp' : 'spSellOutAllSuppliersCollection' }       
      //const sp = {'sp' : 'MySafeSP' }                 
      const data  = {

        'companyId'          : this.company.Id,       
        'dataUltimaVendita'  : this.dataUltimaVendita,
        'seasonIds'          : this.season.Ids,
        'yearIds'            : this.season_year.Ids,
        'departmentIds'      : this.department.Ids,
        'storeId'            : this.store.Id,
        'group_by'           : this.group_by,
        'collection'         : this.collection,
        'cat_groupId'        : this.catGrouping.Id,
        'reportId'           : this.reportId,
        'order_by'           : this.orderBy
        
        /*'orderBy'      : this.orderBy,*/
              
      
      }
      
      // console.log(data)

      const json  = Object.assign(data, sp)

      this.spinner = true
      this.waitModal.show = true
      await api.post(json).then(async res => {
          
          if(res.status==200)
            {

              
              this.waitModal.sentinel = 1
              
              
              this.items = res.data.recordsets[0]
             

              if(this.reportId==1)
              {
                this.items = res.data.recordsets[0].filter(item => item.groupingId == 2)
                const nuovoArray = this.items.map(({ gruppo, ...rest }) => rest);
                this.items = nuovoArray
              }
              else
              {
                this.items = res.data.recordsets[0].filter(item => item.groupingId==1 || item.groupingId == 2)
              
              }   
             
              this.rows = this.items
              this.row_total = res.data.recordsets[0].filter(item=>item.groupingId==3)

              this.cols = this.getTableHeader(this.filteredCols).filter(
                col => col.visible === true || col.visible === undefined)

              if(this.items.length==0)
              {
                this.msg.title = 'ATTENZIONE '
                this.msg.body = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

              /*
              this.filteredCols = this.getTableHeader([]).filter(
                col => col.filter === true )
              */

            }
            else if (res.status==500)
            {
              this.waitModal.sentinel = 3
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type  = 1
              
            }
          
          else
          {
            this.waitModal.sentinel = 2
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type  = 1
                
                        

          }
      }).catch(err=>{
            this.waitModal.sentinel = 3
            this.msg.title = 'ATTENZIONE '
            this.msg.body = err.message
            this.msg.type  = 1
              

      }).finally(() => {
          this.spinner = false
        });
      
 

    }
  }
};
</script>
<style scoped>



.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}






h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}
.card-header
{
  _height: 45px;
}
.btn-warning{
  background-color : rgb(193, 193, 126);
    color            : black ;
  
}


.group
{
  color: green;
  font-size: 22px;
  
}


label {
  cursor: pointer;
}


/*
input[type=date]:invalid {
  border : 2px solid #c91c1c;
}
input[type="date"]:valid {
  border: 2px solid green;
}
  */
</style>